

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IsMobile } from 'app/app';
import { DisplayMode, MarketingItem } from 'app/modules/cms/model/marketing-campaign-models';
import { openDocument } from 'app/modules/corporate/service/corporate.service';
import { IRootState } from 'app/shared/reducers';
import { getDocumentPathFromOfferSku, scrollToTop } from 'app/shared/util/method-util';
import { isArray, isNull } from 'lodash';
import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, Row } from 'reactstrap';
import { notAsked, RD, SRD, success } from 'srd';
import packageJson from '../../../../../../../package.json';

import { getContent } from 'app/modules/cms/service/store/cms-selectors';
import { CmsPageContentType } from 'app/modules/cms/tools/types';
import { isEndStep } from 'app/modules/journey/service/store/step.selector';
import './footer.scss';
import moment from 'moment';
import { useHistory } from 'react-router-dom';

const Footer = ({ didomi, spbLogoUrl, offerSku }) => {

  const REACT_APP_VERSION = packageJson.version.replace('-SNAPSHOT', '');
  const dispatch = useDispatch()

  const isMobile = useContext(IsMobile);
  const [footerSRD, setFooterSRD] = React.useState<RD<string, any[]>>(notAsked())

  const marketingStore = useSelector((state: IRootState) => state.cms.marketing)
  const documentUrl = useSelector((state: IRootState) => state.config.documentUrl);
  const documentPath = documentUrl ?? (offerSku && getDocumentPathFromOfferSku(offerSku));
  const cmsContent = useSelector((state: IRootState) => state.cms.content)[CmsPageContentType.APP_GLOBAL_TYPE]
  const _isEndStep = useSelector(isEndStep);

  let infoPopinContent: MarketingItem[] = [];
  const history = useHistory();

  useEffect(() => {
    if (marketingStore.marketingItems) {
      infoPopinContent = marketingStore.marketingItems[DisplayMode.INFO_POP_IN];
      if (isArray(infoPopinContent) && infoPopinContent.length > 0)
        setFooterSRD(success(infoPopinContent))
    } else {
      setFooterSRD(success([]))
    }
  }, [marketingStore]);


  const showMarketing = (content) => {
    return content.map((item, index) => {
      const classNames = "footerFlexBoxItem footerFlexBoxItem" + ++index;
      return (
        <div className={classNames} key={index}>
          <img alt='cover' src={item.iconURL} />
          <p>
            {item.title}
          </p>
        </div>
      )
    })
  }

  const gestionCookies = (didomiObject) => {
    console.log(didomiObject)
    if (didomiObject) didomiObject.preferences.show();
  }

  
  const handleOpenDocument = (url, type) => {
    dispatch(openDocument(url, type));
  }

  const FooterContent = ({ content }) => {
    return (
      <div className="footerWrapper">
        {!isMobile && content?.length > 0 && <Row className="aboveFooter">
          <Col md="12" className="footerContainer">
            <div className="footerFlexBoxContainer">
              {showMarketing(content)}
              <Button color="primary" className="scrollButton" onClick={() => scrollToTop()}>
                <FontAwesomeIcon icon="arrow-up" size="lg" />
              </Button>{' '}
            </div>

          </Col>
        </Row>
        }
        {isMobile && <Row className="mobileAboveFooter">
          <Col md="12">
            <div className="footerFlexBoxContainer">
              <div className="footerMobileFlexBoxItem">
                <div className="mobileWidgetItems">
                  <div className="widgetHeader"></div>
                </div>

              </div>
              <div className="footerMobileFlexBoxItem">
                <div className="mobileWidgetItems">
                  <div className="widgetHeader"></div>
                </div>
              </div>
              <div className="footerMobileFlexBoxItem">
                <div className="mobileWidgetItems">
                  <div className="widgetHeader"></div>
                </div>
              </div>
            </div>

          </Col>
        </Row>}


 <footer className="footer-root">
      <div className="container-fluid px-0">
        <div className="footer-contact text-center text-white">
          <h4 className="footer-contact-title mb-0">
            Pour toute question relative à votre demande, vous pouvez contacter l&apos;un de nos conseillers au :
          </h4>

          <div className="footer-phone-row mt-2">
            <p className="footer-phone-number mb-0">09 70 82 03 68</p>
            <p className="footer-phone-note mb-0">Numéro non surtaxé</p>
          </div>

          <p className="footer-contact-hours mt-2 mb-0">
            Du lundi au vendredi de 8h a 20h et le samedi de 9h30 a 20h hors jours légalement chômés et / ou fériés et sauf interdiction légale ou réglementaire.
          </p>
        </div>

        <div className="footer-bottom-row d-flex align-items-center justify-content-center position-relative">
          {!isMobile && (
            <div className="footer-logo-circle">
              <img height={50} src={"/content/images/SPB-Logo.png"} className="footer-logo-text"/>
            </div>
          )}

          <div
            className={`footer-links d-flex align-items-center ${
              isMobile ? 'flex-column' : 'flex-row'
            }`}
          >
            <button
              type="button"
              className="footer-link btn btn-link p-0"
              onClick={() => handleOpenDocument("https://assurances.spb.eu/mentionsLegales/fr.html", "Mentions légales")}
            >
              Mentions légales
            </button>
            <button
              type="button"
              className="footer-link btn btn-link p-0"
              onClick={() => gestionCookies(didomi)}
            >
              Politique de cookies
            </button>
            <button
              type="button"
              className="footer-link btn btn-link p-0"
              onClick={() => handleOpenDocument("https://assurances.spb.eu/documents/CharteConfidentialite.pdf", "Charte de confidentialité")}
            >
              Charte de confidentialité
            </button>
            <button
              type="button"
              className="footer-link btn btn-link p-0"
              onClick={() => handleOpenDocument("https://assurances.spb.eu/documents/CGU.pdf", "CGU")}
            >
              Conditions Générales d'Utilisation
            </button>
          </div>
        </div>
      </div>
       <div className="spb-footer-version">
          Copyright © {moment().format('YYYY')} version : {REACT_APP_VERSION}
        </div>
    </footer>


       
      </div>
    )
  }

  const view = SRD.match({
    notAsked: () => <div></div>,
    loading: () => <div></div>,
    failure: (e) => <div></div>,
    success: (content) => <FooterContent content={content} />
  }, footerSRD)

  return view;
};

export default Footer;
